import { hasBookableDuration, formatPriceOptionLabel } from '@cfixe-monorepo/shared';

/**
 * Une option de prix « a une durée » (réservable) — wrapper sur le prédicat partagé
 * `hasBookableDuration` (@cfixe/shared), source de vérité unique côté front et back.
 */
export function priceOptionHasDuration(price: { duration_minutes?: number | null }): boolean {
  return hasBookableDuration(price.duration_minutes);
}

/**
 * Libellé d'une option de prix unique (NONE/QUOTE/FREE/FROM/FIXED). Délègue à `formatPriceOptionLabel`
 * (@cfixe/shared) — source de vérité partagée avec le site public. `formattedPrice` est déjà formaté.
 */
export function priceOptionDisplay(
  priceType: string | undefined,
  formattedPrice: string,
  labels: { price_from: string; on_quote: string; free: string },
): string {
  return formatPriceOptionLabel(priceType, formattedPrice, labels);
}
